'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _EduCenterHome = require('./EduCenterHome.css');

var _EduCenterHome2 = _interopRequireDefault(_EduCenterHome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EduCenterHome = (_dec = (0, _reactCssModules2.default)(_EduCenterHome2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(EduCenterHome, _Component);

  function EduCenterHome(props) {
    (0, _classCallCheck3.default)(this, EduCenterHome);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EduCenterHome.__proto__ || (0, _getPrototypeOf2.default)(EduCenterHome)).call(this, props));

    _this.state = {
      title: 'Action center',
      description: 'Learn how to work with your employer to ensure your retirement plan is sustainably invested.',
      url: _config2.default.domain + _config2.default.routes.EduCenterHome
    };
    return _this;
  }

  (0, _createClass3.default)(EduCenterHome, [{
    key: 'render',
    value: function render() {
      var fffIcon = require('../../../static/images/icons/fff-icn-clr.png');
      var dffIcon = require('../../../static/images/icons/dff-icn-clr.png');
      var gefIcon = require('../../../static/images/icons/gef-icn-clr.png');
      var gffIcon = require('../../../static/images/icons/gff-icn-clr.png');
      var pffIcon = require('../../../static/images/icons/pff-icn-clr.png');
      var wffIcon = require('../../../static/images/icons/wff-icn-clr.png');
      var tffIcon = require('../../../static/images/icons/tff-icn-clr.png');
      var fossilFuelsChart = require('../../../static/images/fossil-fuels-chart.png');
      var vinixOwns = require('../../../static/images/vinix-owns.jpg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'large-page-title' },
            'Action center'
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'subtitle' },
            'Learn how to work with your employer to ensure your retirement plan is sustainably invested.'
          )
        ),
        _react2.default.createElement(_components.HomeEduCenter, { noheader: true }),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'answer' },
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'You have the power to create an economy rooted in justice and sustainability'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'We now stand in a critical moment in history where we have already heated the globe by 1\xBAC, and at current emissions rates, we will hit the 1.5\xBAC level deemed safe by scientists in less than a decade. You have the power to help shift trillions of dollars away from climate destruction and into companies that create a new safe, just, and sustainable world.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If you care about the environment and also want to address social inequities in this country, you are not alone. ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://engageforgood.com/stats/', title: '(Even More) Social Impact Statistics You Should Know - Engage for Good', xstrong: true },
                    'Two-thirds of adult Americans'
                  ),
                  ' say that addressing climate change and doing more to protect our environment should be a top priority for our president and for congress. Just over seventy percent believe that companies have more responsibility than ever before to address social justice issues. Unfortunately, if you participate in an employee-sponsored retirement plan in the U.S., you may be helping finance these problems unknowingly.'
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'Retirement plans by the numbers'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'https://www.bls.gov/opub/ted/2021/67-percent-of-private-industry-workers-had-access-to-retirement-plans-in-2020.htm', title: '67 percent of private industry workers had access to retirement plans in 2020 - U.S. Bureau of Labor Statistics', xstrong: true },
                      '64% of private industry workers'
                    ),
                    ' have access to a defined contribution retirement plan like a 401(k)'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'https://www.gao.gov/products/gao-21-25', title: 'Defined Contribution Plans: Federal Guidance Could Help Mitigate Cybersecurity Risks in 401(k) and Other Retirement Plans - U.S. Governement Accountability Office', xstrong: true },
                      'Over 100 million people'
                    ),
                    ' participate in employer-sponsored retirement plans'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    '401(k)s and other employer-sponsored retirement plans have ',
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'https://www.ici.org/statistical-report/ret_21_q1', title: 'Retirement Assets Total $35.4 Trillion in First Quarter 2021 - Investment Company Institute', xstrong: true },
                      '$10 trillion invested'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For most employees, once you have elected your retirement plan options, it is time to sit back and watch your money grow until retirement. Retirement plans often use mutual funds as the plan investment options - 66% of 401(k) assets ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://www.ici.org/faqs/faq/401k/faqs_401k', title: 'Frequently Asked Questions About 401(k) Plan Research - Investment Company Institute', xstrong: true },
                    'are in mutual funds.'
                  ),
                  ' But those funds can invest in a wide array of securities, and it is not always easy to investigate what\u2019s inside. Most people would not choose to invest in the destruction of the Amazon rainforest, or to profit from climate change, but they unknowingly do.'
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'The environmental impacts'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Retirement plans are heavily invested in companies with climate-harming business models that are not aligned with the Paris Climate Agreement.'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: fffIcon, alt: 'Fossil fuels' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Fossil fuels'
                    ),
                    ' -  Coal, oil, and gas release carbon pollution that accelerates the climate emergency.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: dffIcon, alt: 'Deforestation' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Deforestation'
                    ),
                    ' - Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'The social impacts'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'The social impacts of the companies invested in by retirement plans can include racial and gender injustice, gun violence, and state violence.'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: gefIcon, alt: 'Gender equality' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Gender equality'
                    ),
                    ' - Collecting data and scoring companies on gender equality is the first step towards sustainable change.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: gffIcon, alt: 'Civilian firearms' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Civilian firearms'
                    ),
                    ' - Retirement plans are investing in firearm manufacturers and retailers who generate billions of dollars from handgun, assault rifle, and ammunition sales.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: pffIcon, alt: 'Prison industrial complex' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Prison industrial complex'
                    ),
                    ' - Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: wffIcon, alt: 'Military weapons' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Arms manufacturers and military contractors'
                    ),
                    ' - Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-text-flex' },
                  _react2.default.createElement('img', { styleName: 'icon-text-icon', src: tffIcon, alt: 'Tobacco' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-text-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Tobacco'
                    ),
                    ' - Most smokers start before they\u2019re 18. Every day, more than 2,000 young Americans become daily smokers.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'An example: Vanguard Institutional Index (VINIX)'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Let\u2019s say you are looking at your retirement investment options and you see that you own the Vanguard Institutional Index (VINIX) fund, which happens to be one of the most commonly held fund in retirement plans in the U.S. What companies is VINIX investing in? The fund portfolio includes ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Fossil Free Funds', xstrong: true },
                    'oil majors'
                  ),
                  ' ExxonMobil and Chevron; ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Fossil Free Funds', xstrong: true },
                    'coal-fired utilities'
                  ),
                  ' Southern Company and Duke Energy; ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://deforestationfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/profile/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Deforestation Free Funds', xstrong: true },
                    'agribusiness giant'
                  ),
                  ' Archer-Daniels Midland, tied to allegations of deforestation and land-grabbing; ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://weaponfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/weapon-investments/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Weapon Free Funds', xstrong: true },
                    'arms manufacturers'
                  ),
                  ' Raytheon Technologies and Lockheed Martin; as well as companies profiting from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://prisonfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/prison-industrial-complex-investments/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Prison Free Funds', xstrong: true },
                    'prison industrial complex'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://gunfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/gun-investments/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Gun Free Funds', xstrong: true },
                    'gun violence'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://tobaccofreefunds.org/fund/vanguard-institutional-index-fund/VINIX/tobacco-profile/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Tobacco Free Funds', xstrong: true },
                    'tobacco'
                  ),
                  ', and ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://genderequalityfunds.org/fund/vanguard-institutional-index-fund/VINIX/gender-lens-score/FSUSA002Q0/FOUSA00FR3', title: 'Vanguard Institutional Index Fund - Gender Equality Funds', xstrong: true },
                    'gender inequality'
                  ),
                  '.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'VINIX has 6.7% invested in fossil fuels. Let\u2019s say that your 401(k) balance is $100,000, and it\u2019s all invested in VINIX. In this example, that would translate to $6,740 in fossil fuel companies, with $1,240 invested just in ExxonMobil and Chevron.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: 'https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3',
                      title: 'Vanguard Institutional Index Fund - Fossil Free Funds',
                      xstrong: true
                    },
                    'See more about VINIX',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('img', {
                    src: vinixOwns,
                    alt: 'VINIX is invested in fosil fuel companies, arms manufacturers, and other environmentally and socially unsustainable industries',
                    styleName: 'vinix-owns-chart'
                  })
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                '\u201CI don\u2019t want to profit from climate change and social inequities, but I am not willing to sacrifice returns\u201D'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Most people say they want to be able to invest in environmentally and socially responsible companies, but are not willing to sacrifice returns to do so. Planning for retirement is first and foremost about setting yourself up for financial security.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'There is a widespread myth that investing sustainably means sacrificing returns. But if anything, the evidence suggests the opposite is true. The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.routes.eduCenterFinRisks, title: 'Financial risks of unsustainable investments', xstrong: true },
                    'can destroy shareholder value.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://www.ussif.org/performance', title: 'Financial Performance with Sustainable Investing - US-SIF', xstrong: true },
                    'A large body of research indicates'
                  ),
                  ' that sustainable investing can provide returns in line with their traditional counterparts, with less risk. The material risks associated with unsustainable business models are sharply highlighted by the performance of the fossil fuel sector over the past decade. ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://ieefa.org/wp-content/uploads/2019/02/Divestment-Brief-February-2019.pdf', title: 'Fossil Fuel Investments: Looking Backwards May Prove Costly to Investors in Today\u2019s Market - IEEFA', xstrong: true },
                    'The oil and gas sector of the S&P 500 has placed dead last in returns for the past decade.'
                  ),
                  ' In 1980 the oil and gas industry represented 29% of the S&P 500, while today that number has fallen to only 5.3%, marking the lowest level in over 40 years.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.domain + '/images/fossil-fuels-chart.png',
                      title: 'Fossil fuel stocks tumble amid a strong overall market'
                    },
                    _react2.default.createElement('img', {
                      src: fossilFuelsChart,
                      alt: 'Fossil fuel stocks tumble amid a strong overall market',
                      styleName: 'fossil-fuel-chart'
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'answer-title' },
                'The rise of ESG investing'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'ESG, or Environmental, Social, and Governance, is an umbrella term for investing in funds that seeks both positive financial returns and long-term positive impacts. Across the world, employees are already seeing that climate change, gender inequality, rainforest destruction, and weapons are destroying their future. Most would not choose to invest in or profit from that destruction. It is clear that people are eager to become a part of the solution. In fact, ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://www.nytimes.com/2019/09/27/business/esg-401k-investing-retirement.html', title: 'Bit by Bit, Socially Conscious Investors Are Influencing 401(k)\u2019s - New York Times', xstrong: true },
                    '67 percent of millennials'
                  ),
                  ' would be more likely to contribute, or increase their plan contributions, if they knew their investments were contributing to social good.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Investors have not just taken notice of the financial decline in fossil fuel investments, they have begun divesting from fossil fuels. Assets committed to divestment have leapt from $52 billion in 2014 to more than $11 trillion today \u2014 a stunning increase of 22,000 percent. ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://350.org/press-release/global-fossil-fuel-divestment-11t/', title: 'Global Fossil Fuel Divestment and Clean Energy Investment Movement Crosses $11 Trillion Milestone', xstrong: true },
                    'Over 1,110 institutions'
                  ),
                  ' have now committed to policies black-listing coal, oil and gas.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'These include sovereign wealth funds, banks, global asset managers and insurance companies, cities, pension funds, health care organizations, universities, faith groups and foundations.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In 2020, the demand for ESG investment options reached a new high. One of the world\u2019s largest investment advisors, BlackRock, released a ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: 'https://www.blackrock.com/corporate/about-us/blackrock-sustainability-survey', title: '', xstrong: true },
                    '2020 survey that highlights this trend:'
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'When comparing focus on ESG factors, 88% of global respondents ranked Environment as the priority most in focus amongst those choices today, reflecting the urgency that is present by climate change.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'ESG integration and Exclusionary Screens (the process of screening out specific assets-like fossil fuels) are the two most popular approaches to sustainable investing globally, with 75% and 65% of global respondents, respectively, currently utilizing of considering utilizing these approaches.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'answer-title' },
              'Steps and tools to align your investments with your values'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'No matter where you are on your journey to aligning your investments with your values, we have collected the resources to help get you started. These resources are meant for people of all levels of financial expertise. Not only will help you understand what your part in the retirement system, but they will also guide you through the steps to investing your values. Let\u2019s get started.'
              )
            )
          )
        ),
        _react2.default.createElement(_components.HomeEduCenter, null),
        _react2.default.createElement(_components.RiskTypeLinks, null)
      );
    }
  }]);
  return EduCenterHome;
}(_react.Component)) || _class);
exports.default = EduCenterHome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EduCenterHome/EduCenterHome.js
// module id = 1473
// module chunks = 0